var map = {
	"./login.js": "/2JB",
	"./notice.js": "fItD",
	"./python.js": "sQwZ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "T88f";


//////////////////
// WEBPACK FOOTER
// ./src/api/apis \.js$
// module id = T88f
// module chunks = 8